import React from "react";
import { routeTypeEnum } from "../../utils/enums/enums";
import { RouteConfig } from "./type";
import ServicesPage from "../../pages/ServicesPage/ServicesPage";
import { AuthModal } from "../../components/Auth/AuthComponents";
import CompanyPolicies from "../../pages/Legal/CompanyPolicies";
import ContactUs from "components/includes/ContactUs/ContactUs";
import { AboutCashQuin } from "components/includes/AboutCashQuin/AboutCashQuin";

// import HomePage from "../../pages/HomePage/HomePage";
// import DashboardPage from "../../pages/DashboardPage/DashboardPage";
const HomePage = React.lazy(() => import("../../pages/HomePage/HomePage"));
const DashboardPage = React.lazy(
  () => import("../../pages/DashboardPage/DashboardPage")
);
const PaymentLandingPage = React.lazy(
  () => import("../../pages/PaymentLandingPage/PaymentLandingPage")
);

const ServiceDeatilsPage = React.lazy(
  () => import("../../pages/ServiseDetailsPage/ServiseDetailsPage")
);

export const routeConfig: RouteConfig[] = [
  {
    path: "/",
    routetype: routeTypeEnum.public,
    component: HomePage,
    componentProps: "",
    text: "HomePage",
    className: "",
    data: {},
    options: {
      showInHeader: true,
      showInFooter: false,
      showInSidebar: false,
    },

    ischild: false,
    children: [],
  },
  {
    path: "/contectUs",
    routetype: routeTypeEnum.public,
    component: ContactUs,
    componentProps: "",
    text: "contectUs",
    className: "",
    data: {},
    options: {
      showInHeader: true,
      showInFooter: true,
      showInSidebar: false,
    },

    ischild: false,
    children: [],
  },
  {
    path: "/aboutUs",
    routetype: routeTypeEnum.public,
    component: AboutCashQuin,
    componentProps: "",
    text: "aboutUs",
    className: "",
    data: {},
    options: {
      showInHeader: true,
      showInFooter: false,
      showInSidebar: false,
    },

    ischild: false,
    children: [],
  },
  {
    path: "/privacy-policy",
    routetype: routeTypeEnum.public,
    component: CompanyPolicies,
    componentProps: "",
    text: "Privacy Policy",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: true,
      showInSidebar: false,
    },
    ischild: false,
    children: [],
  },
  {
    path: "/terms-and-conditions",
    routetype: routeTypeEnum.public,
    component: CompanyPolicies,
    componentProps: "",
    text: "Terms & Conditions",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: true,
      showInSidebar: false,
    },
    ischild: false,
    children: [],
  },
  {
    path: "/refunds-cancellations",
    routetype: routeTypeEnum.public,
    component: CompanyPolicies,
    componentProps: "",
    text: "Refunds & Cancellations",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: true,
      showInSidebar: false,
    },
    ischild: false,
    children: [],
  },
  {
    path: "/:categoryName",
    routetype: routeTypeEnum.private,
    component: ServicesPage,
    componentProps: "",
    text: "HomePage",
    className: "",
    data: {},
    options: {
      showInHeader: true,
      showInFooter: false,
      showInSidebar: false,
    },

    ischild: false,
    children: [],
  },
  {
    path: "/dashboard",
    routetype: routeTypeEnum.public,
    component: DashboardPage,
    componentProps: "",
    text: "Dashboard",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: false,
      showInSidebar: true,
    },
    ischild: false,
    children: [],
  },
  {
    path: "/payment",
    routetype: routeTypeEnum.public,
    component: PaymentLandingPage,
    componentProps: "",
    text: "PaymentLandingPage",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: false,
      showInSidebar: true,
    },
    ischild: false,
    children: [],
  },
  {
    path: "/auth",
    routetype: routeTypeEnum.public,
    component: AuthModal,
    componentProps: "",
    text: "Login",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: false,
      showInSidebar: true,
    },
    ischild: false,
    children: [],
  },
  {
    path: "/service-details",
    routetype: routeTypeEnum.private,
    component: ServiceDeatilsPage,
    componentProps: "",
    text: "service_details",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: false,
      showInSidebar: true,
    },
    ischild: false,
    children: [],
  },
  {
    path: "*",
    routetype: routeTypeEnum.public,
    component: HomePage,
    componentProps: "",
    text: "homepage",
    className: "",
    data: {},
    options: {
      showInHeader: false,
      showInFooter: false,
      showInSidebar: true,
    },
    ischild: false,
    children: [],
  },
];

// export const rrrr: any = {
//   HomePage: {
//     path: "/",
//     routetype: routeTypeEnum.public,
//     component: HomePage,
//     componentProps: "",
//     text: "HomePage",
//     className: "",
//     data: {},
//     options: {
//       showInHeader: true,
//       showInFooter: false,
//       showInSidebar: false,
//     },

//     ischild: false,
//     children: [],
//   },
// };
